import {RE_FAILURE, RE_PENDING, RE_SUCCESS} from './constants'

const initialState = {
  data: [],
  error: null,
  isLoading: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RE_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case RE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        ...action.payload,
      }
    case RE_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export {initialState, reducer}
